import { Pipe, PipeTransform } from "@angular/core";
import { formatCurrency, getCurrencySymbol } from "@angular/common";
import { LanguageService } from "../services/language.service";

@Pipe({
  name: "ttcurrency",
})
export class TtcurrencyPipe implements PipeTransform {
  transform(
    value: number,
    currencyCode = "EUR",
    digitsInfo = "0.2-2",
    locale: string = null,
  ): string | null {
    if (locale == null) {
      locale = LanguageService.getCurrentLanguage().toLowerCase();
    }
    if (locale.toUpperCase() === "EL") {
      locale = "EN";
    }
    return formatCurrency(
      value,
      locale,
      getCurrencySymbol(currencyCode, "wide"),
      currencyCode,
      digitsInfo,
    );
  }
}
